module.exports = __webpack_public_path__ + "static/media/title.55241141.svg";